import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Icon from '../common/icons/Icon';
import querystring from 'querystring';
import Pagination from 'rc-pagination';
import USLocale from 'rc-pagination/lib/locale/en_US';
import 'rc-pagination/assets/index.css';

class MovementSpecialistListPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    profiles: PropTypes.object,
  };

  constructor(props) {
    super(props);

    const { search } = props.location;
    const qs = search ? querystring.parse(search.slice(1)) : {};

    this.state = {
      name: qs.name || '',
      page: qs.page || 1,
    };
  }

  setName = e => {
    this.setState({
      name: e.currentTarget.value,
      page: 1,
    });
  };

  setPage = page => {
    this.setState({ page }, this.submitSearch);
  };

  submitSearch = e => {
    if (e) e.preventDefault();

    const { name, page } = this.state;
    const qs = {
      page: page && page > 0 ? page : 1,
    };

    if (name.trim()) {
      qs.name = name;
    }

    this.props.history.push(`${this.props.match.path}?${querystring.stringify(qs)}`);
  };

  render() {
    const { profiles, location } = this.props;
    const { name, page } = this.state;

    return (
      <div>
        <div className="admin-paper">
          <div className="admin-paper__header">
            <h3>Movement Specialists</h3>
            <form onSubmit={this.submitSearch}>
              <input type="text" value={name} onChange={this.setName} placeholder="Search by Name" />
              <button>
                <Icon icon="Search" />
              </button>
            </form>
          </div>
          <ul className="admin-paper__list">
            {profiles.getIn(['data', 'results']).size ? (
              profiles.getIn(['data', 'results']).map(profile => (
                <li key={`profile-${profile.get('id')}`}>
                  <div className="admin-paper__list__title">{profile.get('name')}</div>
                  <Link
                    className="admin-paper__list__link"
                    to={`/movement-specialists/${profile.get('id')}${location.search}`}
                  >
                    View Profile <Icon icon="Arrow" />
                  </Link>
                </li>
              ))
            ) : (
              <div className="admin-paper__no-content">No movement specialists found</div>
            )}
          </ul>
        </div>
        <div className="admin-pagination__wrapper">
          {profiles.getIn(['data', 'pagination', 'rowCount']) > profiles.getIn(['data', 'pagination', 'pageSize']) ? (
            <Pagination
              onChange={this.setPage}
              current={parseInt(page, 10)}
              pageSize={profiles.getIn(['data', 'pagination', 'pageSize'])}
              total={profiles.getIn(['data', 'pagination', 'rowCount'])}
              locale={USLocale}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(state => ({
    profiles: state.ms.profiles,
  }))(MovementSpecialistListPage)
);



// WEBPACK FOOTER //
// ./src/movement-specialists/MovementSpecialistListPage.js